import React, { useState } from 'react';
import './App.css';

type User = {
  name: string
}

const allUsers: User[] = [
  { name: "User 1" },
  { name: "User 2" }
];

const searchResults: User[] = [
  { name: "User 2"}
];

type UserFormProps = {
  users: User[],
  onSearch: (users: User[]) => void
}

function UserForm({ users, onSearch }: UserFormProps) {
  return <div>
    <button onClick={() =>  onSearch(searchResults)}>{"Search for Users"}</button>
    {users.map((asset => {
      return <p>{asset.name}</p>
    }))}
  </div>;
}

function App() {
  let [showingUserForm, setShowingUserForm] = useState(false);
  let [users, setUsers] = useState(allUsers);

  function toggleUserForm() {
    setShowingUserForm(!showingUserForm);
    setUsers(allUsers);
  }

  return (
    <div className="App">
      {/* Working version
        <button onClick={() => toggleUserForm()}>{"Toggle Form"}</button>*/}
      {// Buggy version
        <button onClick={() => setShowingUserForm(!showingUserForm)}>{"Toggle Form"}</button>}
      {showingUserForm && <UserForm users={users} onSearch={setUsers}/>}
    </div>
  );
}

export default App;
